import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

// Import modal
import SendAlertModal from "../modals/SendAlertModal";

const AlertParents = () => {
  const routes = all_routes;
  const [selectedClass, setSelectedClass] = useState("");
  const [alertType, setAlertType] = useState("general");
  const [selectedStudents, setSelectedStudents] = useState<string[]>([]);
  const [alertMessage, setAlertMessage] = useState("");

  // Mock data for testing
  const mockClasses = [
    { id: 1, name: "Grade 10A - Mathematics" },
    { id: 2, name: "Grade 11B - Physics" },
    { id: 3, name: "Grade 9C - Mathematics" },
  ];

  const mockStudents = [
    {
      id: "1",
      name: "Alice Johnson",
      parentEmail: "alice.parent@email.com",
      phone: "+1234567890",
    },
    {
      id: "2",
      name: "Bob Smith",
      parentEmail: "bob.parent@email.com",
      phone: "+1234567891",
    },
    {
      id: "3",
      name: "Carol Davis",
      parentEmail: "carol.parent@email.com",
      phone: "+1234567892",
    },
    {
      id: "4",
      name: "David Wilson",
      parentEmail: "david.parent@email.com",
      phone: "+1234567893",
    },
  ];

  const mockAlertHistory = [
    {
      id: 1,
      type: "Behavior",
      recipient: "Alice Johnson's Parents",
      message: "Excellent participation in class today",
      sentDate: "2024-07-20 10:30",
      status: "Sent",
    },
    {
      id: 2,
      type: "Academic",
      recipient: "Bob Smith's Parents",
      message: "Missing homework assignment from yesterday",
      sentDate: "2024-07-19 15:45",
      status: "Read",
    },
    {
      id: 3,
      type: "Attendance",
      recipient: "Grade 10A - All Parents",
      message: "Parent-teacher meeting scheduled for next Friday",
      sentDate: "2024-07-18 09:00",
      status: "Sent",
    },
  ];

  const alertTemplates = {
    academic: [
      "Student is excelling in class",
      "Missing homework assignment",
      "Needs additional support in subject",
      "Great improvement in performance",
    ],
    behavior: [
      "Excellent classroom behavior",
      "Disruptive behavior in class",
      "Outstanding leadership skills",
      "Needs to improve focus",
    ],
    attendance: [
      "Student was absent today",
      "Frequent tardiness",
      "Perfect attendance this week",
      "Early dismissal requested",
    ],
  };

  const handleStudentSelect = (studentId: string, checked: boolean) => {
    if (checked) {
      setSelectedStudents([...selectedStudents, studentId]);
    } else {
      setSelectedStudents(selectedStudents.filter((id) => id !== studentId));
    }
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedStudents(mockStudents.map((s) => s.id));
    } else {
      setSelectedStudents([]);
    }
  };

  const handleSendAlert = () => {
    if (!selectedClass || selectedStudents.length === 0) {
      alert("Please select a class and students first");
      return;
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherDashboard}>Teacher Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Alert Parents</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Send Alert Form */}
            <div className="col-lg-8">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Send Alert to Parents</h4>
                  <p className="text-muted">
                    Communicate important information to parents instantly
                  </p>
                </div>
                <div className="card-body">
                  <form>
                    {/* Class & Alert Type Selection */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          Select Class <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={selectedClass}
                          onChange={(e) => setSelectedClass(e.target.value)}
                        >
                          <option value="">Choose a class...</option>
                          {mockClasses.map((cls) => (
                            <option key={cls.id} value={cls.name}>
                              {cls.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Alert Type</label>
                        <select
                          className="form-select"
                          value={alertType}
                          onChange={(e) => setAlertType(e.target.value)}
                        >
                          <option value="general">General</option>
                          <option value="academic">Academic</option>
                          <option value="behavior">Behavior</option>
                          <option value="attendance">Attendance</option>
                          <option value="emergency">Emergency</option>
                        </select>
                      </div>
                    </div>

                    {/* Student Selection */}
                    {selectedClass && (
                      <div className="mb-3">
                        <label className="form-label">Select Recipients</label>
                        <div className="card">
                          <div className="card-header py-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  selectedStudents.length ===
                                  mockStudents.length
                                }
                                onChange={(e) =>
                                  handleSelectAll(e.target.checked)
                                }
                              />
                              <label className="form-check-label">
                                Select All ({mockStudents.length} students)
                              </label>
                            </div>
                          </div>
                          <div className="card-body">
                            <div className="row">
                              {mockStudents.map((student) => (
                                <div key={student.id} className="col-md-6 mb-2">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={selectedStudents.includes(
                                        student.id
                                      )}
                                      onChange={(e) =>
                                        handleStudentSelect(
                                          student.id,
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <label className="form-check-label">
                                      <strong>{student.name}</strong>
                                      <br />
                                      <small className="text-muted">
                                        {student.parentEmail}
                                      </small>
                                    </label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Message */}
                    <div className="mb-3">
                      <label className="form-label">
                        Message <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        placeholder="Type your message to parents..."
                        value={alertMessage}
                        onChange={(e) => setAlertMessage(e.target.value)}
                      ></textarea>

                      {/* Quick Templates */}
                      {alertType !== "general" && (
                        <div className="mt-2">
                          <small className="text-muted">Quick templates:</small>
                          <div className="mt-1">
                            {alertTemplates[
                              alertType as keyof typeof alertTemplates
                            ]?.map((template, index) => (
                              <button
                                key={index}
                                type="button"
                                className="btn btn-outline-secondary btn-sm me-1 mb-1"
                                onClick={() => setAlertMessage(template)}
                              >
                                {template}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Delivery Options */}
                    <div className="mb-3">
                      <label className="form-label">Delivery Method</label>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultChecked
                            />
                            <label className="form-check-label">Email</label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">SMS</label>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              App Notification
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* TODO Placeholders */}
                    <div className="alert alert-info">
                      <h6>
                        <i className="ti ti-info-circle me-2"></i>TODO: Connect
                        to alerts API
                      </h6>
                      <ul className="mb-0">
                        <li>Send notifications via email/SMS</li>
                        <li>Track delivery status and read receipts</li>
                        <li>Save message templates</li>
                        <li>Schedule delayed alerts</li>
                      </ul>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={
                          !selectedClass || selectedStudents.length === 0
                        }
                        data-bs-toggle="modal"
                        data-bs-target="#sendAlertModal"
                        onClick={handleSendAlert}
                      >
                        <i className="ti ti-send me-1"></i>Send Alert
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        <i className="ti ti-clock me-1"></i>Schedule Later
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#sendAlertModal"
                      >
                        <i className="ti ti-eye me-1"></i>Preview
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Alert History & Stats */}
            <div className="col-lg-4">
              {/* Quick Stats */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Alert Statistics</h5>
                </div>
                <div className="card-body">
                  <div className="row text-center">
                    <div className="col-6">
                      <h4 className="text-primary mb-1">24</h4>
                      <p className="text-muted mb-0">Sent Today</p>
                    </div>
                    <div className="col-6">
                      <h4 className="text-success mb-1">156</h4>
                      <p className="text-muted mb-0">This Week</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Recent Alerts */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Recent Alerts</h5>
                </div>
                <div className="card-body">
                  {mockAlertHistory.map((alert) => (
                    <div
                      key={alert.id}
                      className="d-flex align-items-start mb-3 p-2 border rounded"
                    >
                      <div
                        className={`avatar avatar-sm me-3 ${
                          alert.type === "Academic"
                            ? "bg-primary-transparent"
                            : alert.type === "Behavior"
                            ? "bg-success-transparent"
                            : "bg-warning-transparent"
                        }`}
                      >
                        <i
                          className={`ti ${
                            alert.type === "Academic"
                              ? "ti-book"
                              : alert.type === "Behavior"
                              ? "ti-user-check"
                              : "ti-calendar-check"
                          }`}
                        ></i>
                      </div>
                      <div className="flex-fill">
                        <h6 className="mb-1">{alert.type}</h6>
                        <p className="text-muted mb-1 small">{alert.message}</p>
                        <small className="text-muted">
                          To: {alert.recipient}
                          <br />
                          {alert.sentDate}
                        </small>
                      </div>
                    </div>
                  ))}

                  <Link to="#" className="btn btn-outline-primary btn-sm w-100">
                    View All Alerts
                  </Link>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Quick Actions</h5>
                </div>
                <div className="card-body">
                  <div className="d-grid gap-2">
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="ti ti-template me-1"></i>Manage Templates
                    </button>
                    <button className="btn btn-outline-success btn-sm">
                      <i className="ti ti-users me-1"></i>Parent Contacts
                    </button>
                    <button className="btn btn-outline-info btn-sm">
                      <i className="ti ti-chart-bar me-1"></i>Delivery Reports
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <SendAlertModal />
    </>
  );
};

export default AlertParents;
